import { render, staticRenderFns } from "./OtasukeRepaymentDetails.vue?vue&type=template&id=d4400e90&"
import script from "./OtasukeRepaymentDetails.vue?vue&type=script&lang=js&"
export * from "./OtasukeRepaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports